import { PipeTransform, Injectable, Pipe } from '@angular/core';
import { formatRange } from './format-range';

@Pipe({ name: 'iexRange' })
@Injectable()
export class RangePipe implements PipeTransform {
  public transform(
    value: any,
    style: 'decimal' | 'percent' | 'currency' = 'decimal',
    none = ''
  ): string {
    return formatRange(value, style, none);
  }
}
